import { FC } from 'react'

type UserIconProps = {}

const UserIcon: FC<UserIconProps> = ({}) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.99967 11.25C7.11817 11.25 4.69209 13.2 3.96914 15.8524C3.72709 16.7405 4.49589 17.5 5.41637 17.5H14.583C15.5035 17.5 16.2723 16.7405 16.0303 15.8524C15.3073 13.2 12.8813 11.25 9.99967 11.25Z"
        fill="white"
      />
      <path
        d="M12.9163 5.83341C12.9163 7.44425 11.6105 8.75008 9.99964 8.75008C8.38881 8.75008 7.08301 7.44425 7.08301 5.83341C7.08301 4.22258 8.38881 2.91675 9.99964 2.91675C11.6105 2.91675 12.9163 4.22258 12.9163 5.83341Z"
        fill="white"
      />
    </svg>
  )
}

export default UserIcon
